import React, { useContext, useEffect, useState } from "react";
import { AuthContext } from "../../../Context/AuthContext/AuthContext";
import { ConfigContext } from "../../../Context/ConfigContext/ConfigContext";
import { setTitlePage } from "../../../Services/Config/ConfigService";
import { getLabel } from "../../../Services/Language/LanguageService";
import { baseLang } from "../../../Lang/BaseLang";
import Card from "../../../Components/Card/Card";
import { Calendar } from "primereact/calendar";
import { Button } from "primereact/button";
import { TabPanel, TabView } from "primereact/tabview";
import {
  getHistoricoInventarioQC,
  getInformacionEncabezadoCXP2,
  getInventarioMensualQC,
} from "../../../API/Inventarios/BodegaMateriales/BodegaMaterialesRequests";
import { Tag } from "primereact/tag";
import AgGrid from "../../../Components/Tables/AgGrid/AgGrid";
import ModalCuentasPorPagarCompras from "../../Proveedores/CuentasPorPagar/ModalCXP/ModalCuentasPorPagarCompras";

const InventarioMensualQC = () => {
  const { userAuth } = useContext(AuthContext);
  const { config } = useContext(ConfigContext);
  const [activeIndex, setActiveIndex] = useState(0);
  const [loading, setLoading] = useState(false);
  const [mostrarDetalle, setMostrarDetalle] = useState(false);
  const [data, setData] = useState([]);
  const [dataHistorico, setDataHistorico] = useState([]);
  const [date, setDate] = useState(new Date());
  const [dialogFactura, setDialogFactura] = useState(false);
  const [IdFactura, setIdFactura] = useState(null);

  const obtenerInformacion = async () => {
    setLoading(true);
    setMostrarDetalle(false);
    let tempoResumen = [];
    if (activeIndex === 0) {
      tempoResumen = await getInventarioMensualQC();
      setData(tempoResumen);
    } else if (activeIndex === 1) {
      let year = date.getFullYear();
      let mes = date.getMonth() + 1;
      tempoResumen = await getHistoricoInventarioQC(mes, year);
      setDataHistorico(tempoResumen);
    }
    setLoading(false);
  };

  const habilitarOcultos = () => {
    setMostrarDetalle((prev) => !prev);
  };

  const CategoriaTemplate = (rowData) => {
    const tipo = rowData.NombreTipo || rowData.TipoProducto;
    switch (tipo) {
      case "Quimicos":
        return (
          <Tag
            severity="danger"
            className="col-12"
            value={tipo}
            style={{ backgroundColor: "#FFA0B4" }}
          />
        );
        break;
      case "Colorantes":
        return (
          <Tag
            severity="info"
            className="col-12"
            value={tipo}
            style={{ backgroundColor: "#059BFF" }}
          />
        );
        break;
      case "Spandex":
        return (
          <Tag
            className="col-12"
            value={tipo}
            style={{ backgroundColor: "#ffc605" }}
          />
        );
        break;

      default:
        return <div>{rowData.NombreTipo}</div>;
        break;
    }
  };

  const OpenDocumento = async (rowData) => {
    let informacionEnviar = {
      IdIngreso: rowData?.IdIngresoEnc,
    };
    const tempoCXP = await getInformacionEncabezadoCXP2(informacionEnviar);
    if (tempoCXP?.length > 0) {
      setIdFactura(tempoCXP[0]?.Id);
      setDialogFactura(true);
    }
  };

  const hideDialog = () => {
    setDialogFactura(false);
  };

  //Datos Inventario
  const columns = [
    //Producto
    {
      header: "Producto",
      headerName: "Producto",
      children: [
        {
          header: "IdIngreso",
          headerEn: "",
          field: "IdDetalle",
          className: "small",
          frozen: true,
          alignFrozen: "left",
          onCellDoubleClicked: ({ data }) => {
            if (data?.IdIngresoEnc) {
              OpenDocumento(data);
            }
          },
        },
        {
          field: "IdProducto",
          header: "IdProducto",
          headerEn: "",
          className: "Xsmall",
          frozen: true,
          alignFrozen: "left",
        },
        {
          header: "Promedio",
          headerEn: "",
          field: "Promedio",
          className: "Xsmall",
          hidden: userAuth.IdRol === 1,
        },
        {
          field: "CodigoProducto",
          header: "Codigo Producto",
          className: "small",
          frozen: true,
          alignFrozen: "left",
          onCellDoubleClicked: ({ data }) => {
            if (data?.IdIngresoEnc) {
              OpenDocumento(data);
            }
          },
        },
        {
          field: "NombreProducto",
          header: "Producto",
          className: "large",
          Sumary: "count",
          frozen: true,
          alignFrozen: "left",
          onCellDoubleClicked: ({ data }) => {
            if (data?.IdIngresoEnc) {
              OpenDocumento(data);
            }
          },
        },
        {
          field: "NombreTipo",
          header: "Tipo",
          className: "small",
          Format: "Template",
          body: CategoriaTemplate,
        },
        {
          field: "NombreCategoria",
          header: "NombreCategoria",
          className: "medium",
        },
        {
          field: "Antiguedad",
          header: "Antiguedad",
          headerEn: "Antiguedad",
          className: "small",
          Format: "Center",
        },
        {
          field: "EstadoAntiguedad",
          header: "EstadoAntiguedad",
          headerEn: "EstadoAntiguedad",
          className: "small",
          Format: "Center",
        },
      ],
    },

    //InventarioInicial
    {
      header: "InventarioInicial",
      headerName: "Inventario Inicial",
      children: [
        {
          field: "Inicial",
          header: "Inicial",
          className: "small",
          Format: "Currency",
          Sumary: "sum",
          editable: userAuth.IdRol === 1,
        },
        {
          field: "IPrecioL",
          header: "Precio L",
          className: "small",
          Format: "Currency",
          editable: userAuth.IdRol === 1,
        },
        {
          field: "IMontoL",
          header: "Monto L",
          className: "small",
          Format: "Currency",
          Sumary: "sum",
          editable: userAuth.IdRol === 1,
        },
        {
          field: "IPrecio",
          header: "Precio $",
          className: "small",
          Format: "Currency",
          editable: userAuth.IdRol === 1,
        },
        {
          field: "IMonto",
          header: "Monto $",
          className: "small",
          Format: "Currency",
          Sumary: "sum",
          editable: userAuth.IdRol === 1,
        },
      ],
    },

    //Ingresos
    {
      header: "Ingresos",
      headerName: "Ingresos",
      children: [
        {
          field: "Ingresos",
          header: "Ingresos",
          className: "small",
          Format: "Currency",
          Sumary: "sum",
          hidden: mostrarDetalle,
          editable: userAuth.IdRol === 1,
        },
        {
          field: "IngresosPrecioL",
          header: " Precio L",
          className: "small",
          Format: "Currency",
          hidden: mostrarDetalle,
          editable: userAuth.IdRol === 1,
        },
        {
          field: "IngresosL",
          header: "Monto L",
          className: "small",
          Format: "Currency",
          Sumary: "sum",
          hidden: mostrarDetalle,
          editable: userAuth.IdRol === 1,
        },
        {
          field: "IngresosPrecioD",
          header: "Precio $",
          className: "small",
          Format: "Currency",
          hidden: mostrarDetalle,
          editable: userAuth.IdRol === 1,
        },
        {
          field: "IngresosD",
          header: "Monto $",
          className: "small",
          Format: "Currency",
          Sumary: "sum",
          hidden: mostrarDetalle,
          editable: userAuth.IdRol === 1,
        },
      ],
    },

    //Compras
    {
      header: "Compras",
      headerName: "Compras",
      children: [
        {
          field: "Compras",
          header: "Compras",
          className: "small",
          Format: "Currency",
          Sumary: "sum",
          hidden: !mostrarDetalle,
          editable: userAuth.IdRol === 1,
        },
        {
          field: "CPrecioL",
          header: " Precio L",
          className: "small",
          Format: "Currency",
          hidden: !mostrarDetalle,
          editable: userAuth.IdRol === 1,
        },
        {
          field: "CMontoL",
          header: "Monto L",
          className: "small",
          Format: "Currency",
          Sumary: "sum",
          hidden: !mostrarDetalle,
          editable: userAuth.IdRol === 1,
        },
        {
          field: "CPrecio",
          header: "Precio $",
          className: "small",
          Format: "Currency",
          hidden: !mostrarDetalle,
          editable: userAuth.IdRol === 1,
        },
        {
          field: "CMonto",
          header: "Monto $",
          className: "small",
          Format: "Currency",
          Sumary: "sum",
          hidden: !mostrarDetalle,
          editable: userAuth.IdRol === 1,
        },
      ],
    },

    //Devoluciones
    {
      header: "Devoluciones",
      headerName: "Devoluciones",
      children: [
        {
          field: "Devolucion",
          header: "Devolucion",
          className: "small",
          Format: "Currency",
          Sumary: "sum",
          hidden: mostrarDetalle,
          editable: userAuth.IdRol === 1,
        },
        {
          field: "DPrecioL",
          header: " Precio L",
          className: "small",
          Format: "Currency",
          hidden: mostrarDetalle,
          editable: userAuth.IdRol === 1,
        },
        {
          field: "DMontoL",
          header: "Monto L",
          className: "small",
          Format: "Currency",
          Sumary: "sum",
          hidden: mostrarDetalle,
          editable: userAuth.IdRol === 1,
        },
        {
          field: "DPrecio",
          header: "Precio $",
          className: "small",
          Format: "Currency",
          hidden: mostrarDetalle,
          editable: userAuth.IdRol === 1,
        },
        {
          field: "DMonto",
          header: "Monto $",
          className: "small",
          Format: "Currency",
          Sumary: "sum",
          hidden: mostrarDetalle,
          editable: userAuth.IdRol === 1,
        },
      ],
    },

    //Consumos
    {
      header: "Consumos",
      headerName: "Consumos",
      children: [
        {
          field: "Consumo",
          header: "Consumo",
          className: "small",
          Format: "Currency",
          Sumary: "sum",
          editable: userAuth.IdRol === 1,
        },
        {
          field: "SPrecioL",
          header: "Precio L",
          className: "small",
          Format: "Currency",
          editable: userAuth.IdRol === 1,
        },
        {
          field: "SMontoL",
          header: "Monto L",
          className: "small",
          Format: "Currency",
          Sumary: "sum",
          editable: userAuth.IdRol === 1,
        },
        {
          field: "SPrecio",
          header: "Precio $",
          className: "small",
          Format: "Currency",
          editable: userAuth.IdRol === 1,
        },
        {
          field: "SMonto",
          header: "Monto $",
          className: "small",
          Format: "Currency",
          Sumary: "sum",
          editable: userAuth.IdRol === 1,
        },
      ],
    },

    //Inventario Final
    {
      header: "Inventario Final",
      headerName: "Inventario Final",
      children: [
        {
          field: "Inventario",
          header: "Inventario",
          className: "small",
          Format: "Currency",
          Sumary: "sum",
          editable: userAuth.IdRol === 1,
          // frozen: true,
          // alignFrozen: 'right'
        },
        {
          field: "InvAlmacen",
          header: "InvAlmacen",
          className: "small",
          Format: "Currency",
          Sumary: "sum",
          hidden: userAuth.IdRol === 1,
          editable: userAuth.IdRol === 1,
        },
        {
          field: "InvCocina",
          header: "InvCocina",
          className: "small",
          Format: "Currency",
          Sumary: "sum",
          hidden: userAuth.IdRol === 1,
          editable: userAuth.IdRol === 1,
        },
        {
          field: "DIFF",
          header: "DIFF",
          className: "small",
          Format: "Currency",
          Sumary: "sum",
          hidden: userAuth.IdRol === 1,
          editable: userAuth.IdRol === 1,
        },
        {
          field: "PriceL",
          header: "Price L",
          className: "small",
          Format: "Currency",
          editable: userAuth.IdRol === 1,
          // frozen: true,
          // alignFrozen: 'right'
        },
        {
          field: "MontoL",
          header: "Monto L",
          className: "small",
          Format: "Currency",
          Sumary: "sum",
          editable: userAuth.IdRol === 1,
          // frozen: true,
          // alignFrozen: 'right'
        },
        {
          field: "Price",
          header: "Price $",
          className: "small",
          Format: "Currency",
          editable: userAuth.IdRol === 1,

          // frozen: true,
          // alignFrozen: 'right'
        },
        {
          field: "Monto",
          header: "Monto $",
          className: "small",
          Format: "Currency",
          Sumary: "sum",
          editable: userAuth.IdRol === 1,
          // frozen: true,
          // alignFrozen: 'right'
        },
      ],
    },
  ];

  const table = {
    Columns: columns,
    Data: data,
    loading: loading,
  };

  //Datos Inventario Historicos
  const columns2 = [
    //Producto
    {
      header: "Producto",
      headerName: "Producto",
      children: [
        {
          field: "IdDetalle",
          header: "IdDetalle",
          headerEn: "",
          className: "small",
          frozen: true,
          alignFrozen: "left",
          //   onCellDoubleClicked: ({ data }) => {
          //     if (data?.IdIngresoEnc) {
          //       setIdIngreso(data?.IdIngresoEnc);
          //       setDialogIngresoQC(true);
          //     }
          //   },
        },
        {
          field: "Codigo",
          header: "CodigoProducto",
          className: "small",
          frozen: true,
          alignFrozen: "left",
          Tooltip: "Codigo Producto Inventario",
          //   onCellDoubleClicked: ({ data }) => {
          //     if (data?.IdIngresoEnc) {
          //       setIdIngreso(data?.IdIngresoEnc);
          //       setDialogIngresoQC(true);
          //     }
          //   },
        },
        {
          field: "NombreProducto",
          header: "Producto",
          className: "large",
          Sumary: "count",
          frozen: true,
          alignFrozen: "left",
        },
        {
          field: "TipoProducto",
          header: "Tipo Producto",
          className: "small",
          // frozen: true,
          // alignFrozen: 'left'
          Format: "Template",
          body: CategoriaTemplate,
        },
        {
          field: "NombreCategoria",
          header: "Nombre Categoria",
          className: "medium",
          // frozen: true,
          // alignFrozen: 'left'
        },
        {
          header: "Promedio",
          headerEn: "",
          field: "Promedio",
          className: "Xsmall",
          hidden: userAuth.IdRol === 1,
          // frozen: true,
          // alignFrozen: 'left'
        },
        {
          header: "IdProducto",
          headerEn: "",
          field: "IdProducto",
          className: "Xsmall",
          hidden: userAuth.IdRol === 1,
        },
      ],
    },

    //Antigüedad
    {
      header: "Antigüedad",
      headerName: "Antigüedad",
      children: [
        {
          field: "Antiguedad",
          header: "Antigüedad",
          headerEn: "Antigüedad",
          className: "small",
          Format: "Center",
        },
        {
          field: "EstadoAntiguedad",
          header: "Estado Antigüedad",
          headerEn: "Estado Antigüedad",
          className: "small",
          Format: "Center",
        },
      ],
    },

    //Inventario Inicial
    {
      header: "Inventario Inicial",
      headerName: "Inventario Inicial",
      children: [
        {
          field: "Inicial",
          header: "Inicial",
          className: "small",
          Format: "Currency",
          Sumary: "sum",
          editable: userAuth.IdRol === 1,
        },
        {
          field: "IPrecioL",
          header: "Precio L",
          className: "small",
          Format: "Currency",
          // Sumary: 'sum',
          editable: userAuth.IdRol === 1,
        },
        {
          field: "IMontoL",
          header: "Monto L",
          className: "small",
          Format: "Currency",
          Sumary: "sum",
          editable: userAuth.IdRol === 1,
        },
        {
          field: "IPrecio",
          header: "Precio $",
          className: "small",
          Format: "Currency",
          // Sumary: 'sum',
          editable: userAuth.IdRol === 1,
        },
        {
          field: "IMonto",
          header: "Monto $",
          className: "small",
          Format: "Currency",
          Sumary: "sum",
          editable: userAuth.IdRol === 1,
        },
      ],
    },

    //Compras
    {
      header: "Compras",
      headerName: "Compras",
      children: [
        {
          field: "Compras",
          header: "Compras",
          className: "small",
          Format: "Currency",
          Sumary: "sum",
          editable: userAuth.IdRol === 1,
          hidden: !mostrarDetalle,
        },
        {
          field: "CPrecioL",
          header: "Precio L",
          className: "small",
          Format: "Currency",
          // Sumary: 'sum',
          editable: userAuth.IdRol === 1,
          hidden: !mostrarDetalle,
        },
        {
          field: "CMontoL",
          header: "Monto L",
          className: "small",
          Format: "Currency",
          Sumary: "sum",
          editable: userAuth.IdRol === 1,
          hidden: !mostrarDetalle,
        },
        {
          field: "CPrecio",
          header: "Precio $",
          className: "small",
          Format: "Currency",
          // Sumary: 'sum',
          editable: userAuth.IdRol === 1,
          hidden: !mostrarDetalle,
        },
        {
          field: "CMonto",
          header: "Monto $",
          className: "small",
          Format: "Currency",
          Sumary: "sum",
          editable: userAuth.IdRol === 1,
          hidden: !mostrarDetalle,
        },
      ],
    },

    //Ingresos
    {
      header: "Ingresos",
      headerName: "Ingresos",
      children: [
        {
          field: "Ingresos",
          header: "Ingresos",
          className: "small",
          Format: "Currency",
          Sumary: "sum",
          editable: userAuth.IdRol === 1,
          hidden: mostrarDetalle,
        },
        {
          field: "IngresosPrecioL",
          header: "Precio L",
          className: "small",
          Format: "Currency",
          // Sumary: 'sum',
          editable: userAuth.IdRol === 1,
          hidden: mostrarDetalle,
        },
        {
          field: "IngresosL",
          header: "Monto L",
          className: "small",
          Format: "Currency",
          Sumary: "sum",
          editable: userAuth.IdRol === 1,
          hidden: mostrarDetalle,
        },
        {
          field: "IngresosPRecioD",
          header: "Precio $",
          className: "small",
          Format: "Currency",
          // Sumary: 'sum',
          editable: userAuth.IdRol === 1,
          hidden: mostrarDetalle,
        },
        {
          field: "IngresosD",
          header: "Monto $",
          className: "small",
          Format: "Currency",
          Sumary: "sum",
          editable: userAuth.IdRol === 1,
          hidden: mostrarDetalle,
        },
      ],
    },

    //IConsumos
    {
      header: "IConsumos",
      headerName: "Consumos",
      children: [
        {
          field: "Consumos",
          header: "Consumos",
          className: "small",
          Format: "Currency",
          Sumary: "sum",
          editable: userAuth.IdRol === 1,
        },
        {
          field: "SPrecioL",
          header: "Precio L",
          className: "small",
          Format: "Currency",
          // Sumary: 'sum'
        },
        {
          field: "SMontoL",
          header: "Monto L",
          className: "small",
          Format: "Currency",
          Sumary: "sum",
        },
        {
          field: "SPrecio",
          header: "Precio $",
          className: "small",
          Format: "Currency",
          // Sumary: 'sum'
        },
        {
          field: "SMonto",
          header: "Monto $",
          className: "small",
          Format: "Currency",
          Sumary: "sum",
        },
      ],
    },

    //Inventario Final
    {
      header: "Inventario Final",
      headerName: "Inventario Final",
      children: [
        {
          field: "FInal",
          header: "Final",
          className: "small",
          Format: "Currency",
          Sumary: "sum",
          // frozen: true,
          // alignFrozen: 'right'
        },
        {
          field: "FPrecioL",
          header: "Precio L",
          className: "small",
          Format: "Currency",
          // Sumary: 'sum',
          // frozen: true,
          // alignFrozen: 'right'
        },
        {
          field: "FMontoL",
          header: "Monto L",
          className: "small",
          Format: "Currency",
          Sumary: "sum",
          // frozen: true,
          // alignFrozen: 'right'
        },
        {
          field: "FPrecio",
          header: "Precio $",
          className: "small",
          Format: "Currency",
          // Sumary: 'sum',
          // frozen: true,
          // alignFrozen: 'right'
        },
        {
          field: "FMonto",
          header: "Monto $",
          className: "small",
          Format: "Currency",
          Sumary: "sum",
          // frozen: true,
          // alignFrozen: 'right'
        },
      ],
    },
  ];

  const table2 = {
    Columns: columns2,
    Data: dataHistorico,
    loading: loading,
  };

  useEffect(() => {
    setTitlePage(getLabel(baseLang, "BodegaQC", config.language));
    obtenerInformacion();
  }, [activeIndex, date]);

  return (
    <div className="mt-2">
      <Card
        titulo={
          <div className="botones">
            <h3>{getLabel(baseLang, "BodegaQC2", config.language)}</h3>
            {activeIndex === 1 && (
              <Calendar
                value={date}
                onChange={(e) => setDate(e.value)}
                view="month"
                dateFormat="mm/yy"
                showIcon
              />
            )}
            <Button
              icon="pi pi-sync"
              className="mx-1"
              onClick={obtenerInformacion}
            />
            <Button icon="pi pi-eye" onClick={habilitarOcultos} />
          </div>
        }
        contenido={
          <div
            className="pt-4"
            style={{ height: "90vh" }}
            id="IngresosCombustibles"
          >
            <TabView
              className="col-12 homeTabView"
              activeIndex={activeIndex}
              onTabChange={(e) => setActiveIndex(e.index)}
            >
              <TabPanel header="Inventario Mensual QC">
                <div
                  className="pt-4"
                  style={{ height: "84vh" }}
                  id="ResumenInventarioQC"
                >
                  <AgGrid table={table} />
                </div>
              </TabPanel>
              <TabPanel header="Historico">
                <div className="pt-4" style={{ height: "84vh" }} id="Historico">
                  <AgGrid table={table2} />
                </div>
              </TabPanel>
            </TabView>
          </div>
        }
      />

      <ModalCuentasPorPagarCompras
        dialogCuentas={dialogFactura}
        hideDialog={hideDialog}
        IdFactura={IdFactura}
      />
    </div>
  );
};

export default InventarioMensualQC;
